import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAuth } from '@/hooks/useAuth'
import { Loading } from '@/components/ui/loading'

export const Route = createFileRoute('/onboarding')({
  component: OnboardingRoute,
})

function OnboardingRoute() {
  const { isLoaded, isSignedIn } = useAuth()

  if (!isLoaded) {
    return (
      <div className="flex-1 bg-surface-L0 flex items-center justify-center">
        <Loading size={48} />
      </div>
    )
  }

  if (!isSignedIn) {
    return <Navigate to="/signin" />
  }

  return <Navigate to="/operations/onboarding" />
}
